/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const AuditReportsCompletedStatusDataDtoReasonEnum = {
    LOW_EFFICIENCY: "LOW_EFFICIENCY",
    MISSING_MATERIALS: "MISSING_MATERIALS"
} as const;

export type AuditReportsCompletedStatusDataDtoReasonEnumKey = (typeof AuditReportsCompletedStatusDataDtoReasonEnum)[keyof typeof AuditReportsCompletedStatusDataDtoReasonEnum];

export type AuditReportsCompletedStatusDataDto = {
    /**
     * @type number
    */
    efficiency: number;
    /**
     * @type object
    */
    minEfficiency: object;
    /**
     * @type string | undefined
    */
    comment?: string;
    /**
     * @description Structured reason for completing without export
     * @type string | undefined
    */
    reason?: AuditReportsCompletedStatusDataDtoReasonEnumKey;
};